Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
 
  // Zero-decimal currencies — no subunits, so skip /100
  var zeroDecimals = [
    'BIF','CLP','DJF','GNF','HUF','ISK','JPY','KMF',
    'KRW','PYG','RWF','UGX','VND','VUV','XAF','XOF','XPF'
  ];
  var currencyCode = (Shopify.currency && Shopify.currency.active) || '';
  var isZeroDecimal = zeroDecimals.indexOf(currencyCode) !== -1;
 
  var value = '';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = (format || this.money_format);
 
  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }
 
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
 
    if (isNaN(number) || number == null) { return 0; }
 
    // Skip /100 for zero-decimal currencies
    number = isZeroDecimal
      ? parseFloat(number).toFixed(precision)
      : (number / 100.0).toFixed(precision);
 
    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';
 
    return dollars + cents;
  }
 
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, isZeroDecimal ? 0 : 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, isZeroDecimal ? 0 : 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
 
  return formatString.replace(placeholderRegex, value);
};



document.addEventListener("DOMContentLoaded", function () {
  const popup = document.querySelector("#popup-1");
  const popup_2 = document.querySelector("#popup-2");
  const body = document.querySelector("body");

  
    if (popup){
      // Open popup using event delegation
      document.addEventListener("click", function (e) {
        if (e.target.matches(".which-popup-btn")) {
          popup.style.display = "flex";
          body.classList.add("pop-active");
        }
        // Close popup with top close button
        if (e.target.matches("#popup-1-close")) {
          popup.style.display = "none";
          body.classList.remove("pop-active");
        }
        // Close popup with bottom "Close" button
        if (e.target.matches("#popup-1-close-m")) {
          popup.style.display = "none";
          body.classList.remove("pop-active");
        }
    
        // Close popup when clicking outside
        if (e.target === popup) {
          popup.style.display = "none";
          body.classList.remove("pop-active");
        }
      });
    }

    if (popup_2){
      document.addEventListener("click", function (e) {
        if (e.target.matches(".offer-block-inner") || e.target.matches(".compare-btn") ) {
          e.preventDefault();
          popup_2.style.display = "flex";
          body.classList.add("pop-active");
        }
        // Close popup with top close button
        if (e.target.matches("#popup-2-close")) {
          popup_2.style.display = "none";
          body.classList.remove("pop-active");
        }
    
        // Close popup when clicking outside
        if (e.target === popup_2) {
          popup_2.style.display = "none";
          body.classList.remove("pop-active");
        }
      });
    }

    // Code for Per Sheet Logic

    function getCurrentSheetsValue() {
      const selectedInput = document.querySelector('.product-form__input input:checked');
      const val = selectedInput?.getAttribute('data-t-sheets');
      return val ? parseFloat(val) : null;
    }
  
    function applyCalculation() {
      const tSheetsValue = getCurrentSheetsValue();
    
      const widgetContainers = document.querySelectorAll('.loop-widget-purchase-option');
    
      widgetContainers.forEach(container => {
        const priceElement_m = container.querySelector('.loop-widget-purchase-option-price');
        if (!priceElement_m) return; // agar price wrapper hi nahi hai to skip

        // Step 1: span ko ensure karo - agar nahi hai to create karo
        // Duplicate creation rokne ke liye data-attribute flag use kar rahe hain
        let priceElement = priceElement_m.querySelector('span.p-sheets-span');
        if (!priceElement) {
          priceElement = document.createElement('span');
          priceElement.classList.add('p-sheets-span');
          priceElement_m.appendChild(priceElement);
        }

        const rawText = document.querySelector('.product__info-container variant-selects .product-form__input input:checked+label.has-image .variant-price').textContent || '';
        const symbolMatch = rawText.match(/[^0-9.,\s]+/);
        const currencySymbol = symbolMatch ? symbolMatch[0] : '';
        const numericText = rawText.replace(/[^0-9.]/g, '');
        const price = parseFloat(numericText);
        // console.log(price)
        if (isNaN(price) || price === 0 || !tSheetsValue) {
          priceElement_m.setAttribute('data-compare', '');
          return;
        }
    
        let calculatedValue = 0;
        console.log(container.classList)
        if (container.classList.contains('loop-widget-purchase-option-onetime')) {
          calculatedValue = price - (price * 0.15);
          container.querySelector('.loop-widget-purchase-option-compare-at-price').classList.remove('loop-display-none');
          container.querySelector('.loop-widget-purchase-option-compare-at-price').textContent = rawText;
        }else{
          calculatedValue = price - (price * 0.30);
        }
        priceElement_m.setAttribute('data-compare', rawText);
        priceElement_m.querySelector('.p-sheets-span').innerText = Shopify.formatMoney(calculatedValue);

        const zeroDecimalCurrencies = ['HUF', 'JPY', 'KRW', 'VND', 'CLP', 'ISK', 'RWF', 'UGX'];
        const divisor = zeroDecimalCurrencies.includes(Shopify.currency.active) ? 1 : 100;
        let priceInCurrency = calculatedValue / divisor;
        let calculatedValue_s = ((priceInCurrency / tSheetsValue) * 100).toFixed(2);
        calculatedValue_s = new Intl.NumberFormat(Shopify.locale, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format((priceInCurrency / tSheetsValue) * 100);
        const formattedValue = `(${currencySymbol} ${calculatedValue_s} ${window.setting_persheet})`;
        priceElement.setAttribute('data-p-sheets', formattedValue);
      });
    }
  
    // Subscription widget: "change or cancel anytime" point -> cancellation rule linked to the policy
    const cancelWords = /cancel|prekli[cč]|otka|annull|zruš|anul|lemond|mondhat|kündig/i;
    function applyCancelRule() {
      if (!window.setting_cancel_rule) return;
      document.querySelectorAll('.loop-widget-spg-container ul').forEach(list => {
        if (list.querySelector('.cancel-rule-link')) return;
        const item = Array.from(list.querySelectorAll('li')).find(li => cancelWords.test(li.textContent));
        if (!item) return;
        const link = document.createElement('a');
        link.className = 'cancel-rule-link';
        link.href = window.setting_cancel_rule_url;
        link.textContent = window.setting_cancel_rule;
        item.classList.add('cancel-rule');
        item.replaceChildren(link);
      });
    }

    let mutationTimer;
    const observer = new MutationObserver(() => {
      clearTimeout(mutationTimer);
      mutationTimer = setTimeout(() => {
        applyCancelRule();
        const tSheetsValue = getCurrentSheetsValue();
        if(tSheetsValue != null){
          applyCalculation();
        }
      }, 100);
    });
  
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  
    applyCalculation();
    applyCancelRule();

    let default_val = document.querySelector(".product-form__input input.input_48+label");
    if(default_val && window.location.href.includes('/products') && !window.location.href.includes('?variant')){
      // if(window.location.href.includes('/sl-si/'))
        setTimeout(function(){
        default_val.click();
        }, 2000)
      // else
      //   default_val.click();
    }

    // $('#cart__discout-input').val('OLIROLI15');
    // $('button#cart__discout-submit').click();

    // async function checkCountry() {
    //   try {
    //     const response = await fetch("https://oliroli.com/browsing_context_suggestions.json");
    //     const data = await response.json();
    //     const countryHandle = data?.detected_values?.country?.handle;
    //     console.log(countryHandle)
    //     if (countryHandle && countryHandle.toUpperCase() === "SI") { 
    //       $('li#wg-sl').click();
    //     } else if (countryHandle && countryHandle.toUpperCase() === "HR") { 
    //       $('li#wg-hr').click();
    //     } else{
    //       console.log($('li#wg-'+$('html').attr('lang')))
    //       $('li#wg-'+$('html').attr('lang')).click();
    //     }
    //   } catch (error) {
    //     console.error("Error fetching data:", error);
    //   }
    // }

    // checkCountry();
});

$(document).on('click', 'button#cart__discout-submit', function() {
    let code = $('#cart__discout-input').val();
    $('.cart__discount-active .error').remove();
    $('.cart__discount-active-tags span').each(function(){
      code += ', '+$(this).attr('data-code');
      console.log(code)
    })
    console.log(code)
    if(code.length){
        let _this = $(this);
        _this.prop('disabled', true).addClass('loading');
        _this.find('.loading__spinner').removeClass('hidden');
        var formData = new FormData();
        formData.append("discount", code);
        
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => {
            _this.prop('disabled', false).removeClass('loading');
            _this.find('.loading__spinner').addClass('hidden');
            if(data.discount_codes[0].applicable){
                $('div#main-cart-items').load(location.href+' div#main-cart-items');
                $('div#main-cart-footer').load(location.href+' div#main-cart-footer');
                // $('.cart__discount-active .cart__discount-active-tags').append(`<span>${data.discount_codes[0].code}<svg width="20" height="20" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg" style="fill: #39B37C;"><path d="M9.9 22L8.5 20.6L14.1 15L8.5 9.4L9.9 8L15.5 13.6L21.1 8L22.5 9.4L16.9 15L22.5 20.6L21.1 22L15.5 16.4L9.9 22Z">/path></svg></span>`);
            }else{
                $('#cart__discout-input').val('');
                $('.cart__discount-active').append(`<span class="error">⚠︎ Not Applicable.</span>`);
            }
        });
    }else{
        $('#cart__discout-input').focus();
    }
})

$(document).on('click', '.cart__discount-active-tags span svg', function() {
    $(this).closest('span').remove();

    let codesArray = [];

    $('.cart__discount-active-tags span').each(function(){
        const code = $(this).attr('data-code');
        if (code) {
            codesArray.push(code);
        }
    });

    let code = codesArray.length > 0 ? codesArray.join(', ') : '';

    
    var formData = new FormData();
    formData.append("discount", code);
    
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      $('div#main-cart-items').load(location.href+' div#main-cart-items');
      $('div#main-cart-footer').load(location.href+' div#main-cart-footer');
    });
})

$(document).on('click', '.footer-block--menu .footer-block__heading', function() {
    $(this).toggleClass('opened');
    $(this).siblings('ul').slideToggle(300);
})

// Add this to your site's theme/custom JS
// const observer_1 = new MutationObserver(() => {
//   document.querySelectorAll('.klaviyo-form').forEach(form => {
//     // Replace validation messages
//     form.querySelectorAll('[data-testid]').forEach(el => {
//       // if (el.textContent === 'NOTIFY WHEN BACK IN STOCK') {
//       //   el.textContent = 'OBVESTI, KO BO PONOVNO NA ZALOGI'; // your translation
//       // }
//       // if (el.textContent === "We'll send you an email when this product is back in stock!") {
//       //   el.textContent = 'Poslali vam bomo e-pošto, ko bo ta izdelek spet na zalogi!';
//       // }
//       // console.log(el)
//       // if (el.textContent === "Enter your email") {
//       //   el.textContent = 'Vnesite svoj e-poštni naslov';
//       // }
//       // if (el.textContent === "Notify Me!") {
//       //   el.textContent = 'Obvesti me!';
//       // }
//     });
//   });
// });
const translations = {
  'NOTIFY WHEN BACK IN STOCK': 'OBVESTI, KO BO PONOVNO NA ZALOGI',
  "We'll send you an email when this product is back in stock!":"Poslali vam bomo e-pošto, ko bo ta izdelek spet na zalogi!",
  "Enter your email":"Vnesite svoj e-poštni naslov",
  'Notify Me!': 'Obvesti me!',
  'Notify me': 'Obvesti me',
  "YOU'RE ALL SET!": 'Vse je pripravljeno!',
  "Keep an eye out for a back-in-stock message.": 'Bodite pozorni na sporočilo, ko bo izdelek spet na zalogi.',
};

if(window.location.href.includes('/sl-si/')){
  const observer_1 = new MutationObserver(() => {
    document.querySelectorAll('.klaviyo-form, [class*="kl-private-reset"]').forEach(form => {
      const walker = document.createTreeWalker(
        form,
        NodeFilter.SHOW_TEXT, // only text nodes
        null,
        false
      );

      let node;
      while (node = walker.nextNode()) {
        const trimmed = node.textContent.trim();
        if (translations[trimmed]) {
          node.textContent = translations[trimmed];
        }
      }

      form.querySelectorAll('input, textarea').forEach(input => {
        const ph = input.getAttribute('placeholder');
        if (ph && translations[ph.trim()]) {
          input.setAttribute('placeholder', translations[ph.trim()]);
        }
      });
    });

    document.querySelectorAll('button.needsclick').forEach(btn => {
      const trimmed = btn.textContent.trim();
      if (translations[trimmed]) {
        // Use TreeWalker here too to preserve inner HTML
        const walker = document.createTreeWalker(
          btn,
          NodeFilter.SHOW_TEXT,
          null,
          false
        );
        let node;
        while (node = walker.nextNode()) {
          const t = node.textContent.trim();
          if (translations[t]) {
            node.textContent = translations[t];
          }
        }
      }
    });

  });

  observer_1.observe(document.body, { childList: true, subtree: true });
}